import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { ActionInput, StyledFlex } from '@dreryk/react-components';

import { consentTemplateActionTranslationKeys } from '../../../../translations';

import { ConsentTemplateActionFormBean } from './ConsentTemplateActionForm.types';
import { ConsentTemplateTable } from './table/ConsentTemplateTable';

const t = consentTemplateActionTranslationKeys.modal.form;

type ConsentTemplateActionFormProps = {
   readonly onApproveAndPrint: VoidFunction;
   readonly patientId: number;
   readonly visitId: number;
   readonly priorityTemplateIds: number[];
};

export const ConsentTemplateActionForm = (props: ConsentTemplateActionFormProps): ReactElement => {
   const { register, watch } = useFormController<ConsentTemplateActionFormBean>({
      searchText: null,
   });

   const searchText = watch('searchText');

   return (
      <StyledFlex as={'form'} gap={18} direction={'column'} noValidate autoComplete={'off'}>
         <ActionInput
            controller={register('searchText')}
            testId={'searchText'}
            placeholder={t.actionInput.placeholder}
            autoFocus
         />

         <ConsentTemplateTable
            onApproveAndPrint={props.onApproveAndPrint}
            patientId={props.patientId}
            visitId={props.visitId}
            searchText={searchText}
            priorityTemplateIds={props.priorityTemplateIds}
         />
      </StyledFlex>
   );
};
